import { JSX } from "@liebherr/patternlib";
import React, { useRef } from "react";
import { wrapWc } from "wc-react";

type DropOnONLh<T> = {
  [K in keyof T as K extends `onLh${infer I}` ? `lh${I}` : K]: T[K];
};
export type PLGalleryCarouselItemProps = DropOnONLh<JSX.PatternlibGalleryCarouselItem>;
export type PLGalleryCarouselItemExtendedProps = PLGalleryCarouselItemProps & React.HTMLAttributes<unknown> & React.RefAttributes<unknown>;

const WrappedGalleryCarouselItem = wrapWc<JSX.PatternlibGalleryCarouselItem>("patternlib-gallery-carousel-item");
export const useRefPLGalleryCarouselItem = () => useRef<HTMLPatternlibGalleryCarouselItemElement>(null);

const PLGalleryCarouselItem = React.forwardRef<HTMLPatternlibGalleryCarouselItemElement, PLGalleryCarouselItemExtendedProps>((props, ref) => {
  const myRef = useRefPLGalleryCarouselItem();
  return (
    <WrappedGalleryCarouselItem ref={ref ?? myRef} {...props}>
      {props.children}
    </WrappedGalleryCarouselItem>
  );
});
PLGalleryCarouselItem.displayName = "PLGalleryCarouselItem";

export default PLGalleryCarouselItem;
